import { render, staticRenderFns } from "./AbkNews.vue?vue&type=template&id=32963ae6&scoped=true&"
import script from "./AbkNews.vue?vue&type=script&lang=js&"
export * from "./AbkNews.vue?vue&type=script&lang=js&"
import style0 from "./AbkNews.vue?vue&type=style&index=0&id=32963ae6&scoped=true&lang=scss&"
import style1 from "./AbkNews.vue?vue&type=style&index=1&id=32963ae6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32963ae6",
  null
  
)

export default component.exports